import UpsAddressValidationViewController from './UpsAddressValidationViewController';

export default UpsAddressValidationViewController;
